export enum filterTypesEnum {
  simple = 0,
  advance = 1,
}

export enum FilterTypesInWords {
  simple = 'simple',
  advance = 'advance',
}

export enum FilterInputsTypesEnum {
  input = 'input',
  operator = 'operator',
  compareTo = 'compareTo',
  condition = 'condition',
  mapBy = 'mapBy',
  predicate = 'predicate',
  optionalId = 'optionalId',
  async = 'async',
  additionalFields = 'additionalFields',
}

export enum FilterOptionsTypesEnum {
  list = 'list',
  'tagsList' = 'tagsList',
  string = 'string',
  number = 'number',
  date = 'date',
  boolean = 'boolean',
  hybrid = 'hybrid',
  group = 'group',
}
